import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import { PasswordRequirements } from '@/components/ui/password-requirements';
import { passwordRulesPass } from '@/utils/password-rules';
import { type FieldProps, field } from './signup-field-helpers';

function PasswordInputs({
  data,
  onChange,
  invalid,
}: FieldProps & { invalid: boolean }): ReactNode {
  return (
    <>
      <FieldInput
        type="password"
        placeholder="Contraseña"
        value={data.password}
        onChange={field(data, onChange, 'password')}
        invalid={invalid}
      />
      <FieldInput
        type="password"
        placeholder="Repetir contraseña"
        value={data.password_confirm}
        onChange={field(data, onChange, 'password_confirm')}
        invalid={invalid}
      />
    </>
  );
}

export function AccountFields({
  data,
  onChange,
  errors,
}: FieldProps): ReactNode {
  const submitted = !!(errors?.password || errors?.password_confirm);
  const panelVisible = !!data.password || !!data.password_confirm || submitted;
  const invalid =
    submitted && !passwordRulesPass(data.password, data.password_confirm);
  return (
    <>
      <PasswordInputs data={data} onChange={onChange} invalid={invalid} />
      <PasswordRequirements
        password={data.password}
        confirm={data.password_confirm}
        visible={panelVisible}
      />
    </>
  );
}
